export function formatPlayTimeSeconds(
	diffInSeconds: number,
): [number, number, number] {
	const days = Math.floor(diffInSeconds / (24 * 3600));

	let remainder = diffInSeconds % (24 * 3600);
	const hours = Math.floor(remainder / 3600);
	remainder %= 3600;

	const minutes = Math.floor(remainder / 60);

	return [days, hours, minutes];
}
